import { useEffect, useReducer, useRef } from 'react';

function reducer(state, action) {
  switch (action.type) {
    case 'set':
      return action.value;
    default:
      throw new Error('[useBroadcast] no support action');
  }
}

function useBroadcast<T>(name: string, initialState?: T) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const ref = useRef<BroadcastChannel>();

  useEffect(() => {
    if ('BroadcastChannel' in window) {
      ref.current = new BroadcastChannel(name);

      // eslint-disable-next-line func-names
      ref.current.onmessage = function (event) {
        event.preventDefault();
        const { data: value } = event;
        dispatch({ type: 'set', value });
      };
    }
  }, [name]);

  function setState(value: string = 'ok') {
    if (ref.current) {
      ref.current.postMessage(value);
      dispatch({ type: 'set', value });
    }
  }

  return [state as T | undefined, setState] as const;
}

export function useBroadcastVerify() {
  return useBroadcast<'ok' | undefined>('verify');
}
